// Configurações padrão para filamentos da Bambu Lab
export const defaultFilamentSettings = {
    activate_air_filtration: ["0"],
    additional_cooling_fan_speed: ["0"],
    chamber_temperatures: ["0"],
    close_fan_the_first_x_layers: ["1"],
    compatible_printers: [],
    compatible_printers_condition: "",
    compatible_prints: [],
    compatible_prints_condition: "",
    complete_print_exhaust_fan_speed: ["80"],
    cool_plate_temp: ["35"],
    cool_plate_temp_initial_layer: ["35"],
    default_filament_colour: [""],
    during_print_exhaust_fan_speed: ["60"],
    enable_overhang_bridge_fan: ["1"],
    enable_pressure_advance: ["0"],
    eng_plate_temp: ["45"],
    eng_plate_temp_initial_layer: ["45"],
    fan_cooling_layer_time: ["60"],
    fan_max_speed: ["100"],
    fan_min_speed: ["20"],
    filament_cost: ["0"],
    filament_density: ["0"],
    filament_deretraction_speed: ["nil"],
    filament_diameter: ["1.75"],
    filament_end_gcode: [" "],
    filament_flow_ratio: ["1"],
    filament_is_support: ["0"],
    filament_long_retractions_when_cut: ["nil"],
    filament_max_volumetric_speed: ["2"],
    filament_minimal_purge_on_wipe_tower: ["15"],
    filament_notes: "",
    filament_retract_before_wipe: ["nil"],
    filament_retract_restart_extra: ["nil"],
    filament_retract_when_changing_layer: ["nil"],
    filament_retraction_distances_when_cut: ["nil"],
    filament_retraction_length: ["nil"],
    filament_retraction_minimum_travel: ["nil"],
    filament_retraction_speed: ["nil"],
    filament_scarf_gap: ["0"],
    filament_scarf_height: ["0%"],
    filament_scarf_length: ["10"],
    filament_scarf_seam_type: ["none"],
    filament_settings_id: ["(modelo_3d.3mf)"],
    filament_shrink: ["100%"],
    filament_soluble: ["0"],
    filament_start_gcode: [" "],
    filament_type: ["PLA"],
    filament_vendor: ["(Undefined)"],
    filament_wipe: ["nil"],
    filament_wipe_distance: ["nil"],
    filament_z_hop: ["nil"],
    filament_z_hop_types: ["nil"],
    from: "project",
    full_fan_speed_layer: ["0"],
    hot_plate_temp: ["45"],
    hot_plate_temp_initial_layer: ["45"],
    inherits: "",
    name: "(modelo_3d.3mf)",
    nozzle_temperature: ["200"],
    nozzle_temperature_initial_layer: ["200"],
    nozzle_temperature_range_high: ["240"],
    nozzle_temperature_range_low: ["190"],
    overhang_fan_speed: ["100"],
    overhang_fan_threshold: ["95%"],
    overhang_threshold_participating_cooling: ["95%"],
    pressure_advance: ["0.02"],
    reduce_fan_stop_start_freq: ["0"],
    required_nozzle_HRC: ["0"],
    slow_down_for_layer_cooling: ["1"],
    slow_down_layer_time: ["5"],
    slow_down_min_speed: ["10"],
    supertack_plate_temp: ["35"],
    supertack_plate_temp_initial_layer: ["35"],
    temperature_vitrification: ["100"],
    textured_plate_temp: ["45"],
    textured_plate_temp_initial_layer: ["45"],
    version: "1.10.2.76"
}; 